//----- Component --------------------------------------------------------/
// Developer : Daiana Curcio
// Creation Date : 4/10/24
// Version : 1
// Description : pantalla para autorizaciones de modificaciones de stock y conversiones
//
//------Changes --------------------------------------------------------------------- -------------//
// Change Date :
// Change by :
// Change description:
//
// Change Date :
// Change by
// Change description:
//
//========================================================================/
import React, { useState, useEffect, useMemo } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { styled } from "@mui/material/styles";
import { UrlApi } from "../../services/apirest";
import MaterialReactTable, {
  MRT_FullScreenToggleButton,
} from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es"; //Tabla en español
import {
  Button,
  Container,
  Box,
  Typography,
  Stack,
  Grid,
  Tooltip,
  IconButton,
  TextField,
  Autocomplete,
} from "@mui/material";
import { createTheme, ThemeProvider, useTheme } from "@mui/material";
import { logEventos } from "../../services/services";
//ICONOS
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import Navbar from "../Navbar";
import Dialog_aut_modif from "./Dialog_aut_modif";


function Autorizar_modificaciones() {
  const [abrirConfirmacion, setAbrirConfirmacion] = useState(false);
  const [tabla, setTabla] = useState(true);
  const [update, setUpdate] = useState(false);
  const [articuloRow, setArticuloRow] = useState();

 // console.log("articulo row",articuloRow);
  
  useEffect(() => {
    logEventos(
      "Acceso al menú Stock Autorizar Modificaciones",
      "Stock Autorizar Modificaciones",
      "Autorizar o rechazar modificaciones como conversión y ajuste",
      localStorage.getItem("user")
    );
  }, []);

  const [modificaciones, setModificaciones] = useState();

  const obtenerModificaciones = () => {
    fetch(UrlApi + "/stock_transacciones/conModificacionesParaAutorizar")
      .then((data) => data.json())
      .then((data) => setModificaciones(data));
  };

 //console.log("Modificaciones para autorizar", modificaciones);

  //funcion que espera los cambios de la funcion de obtener a los articulos
  useEffect(() => {
    obtenerModificaciones();
  }, [tabla]);

  const handleOpenConfir = (value) => {
    setAbrirConfirmacion(value);
    setUpdate(true);
  };

  useEffect(() => {
    if (update) {
      obtenerModificaciones();
      setUpdate(false);
    }
  }, [update]);

  const columns = useMemo(
    () => [
      { header: "Artículo", accessorKey: "nombre_articulo", size: 100 },
      { header: "Descripción", accessorKey: "descripcion", size: 100 },
      { header: "Tipo", accessorKey: "tipo_transaccion", size: 70 },
      { header: "Cant.Ajuste", accessorKey: "cantidad_recibida", size: 100 },
      { header: "Cant.Conversion", accessorKey: "cantidad_enviada", size: 100 },
      { header: "Convertido A", accessorKey: "art_convertido", size: 100 },
      { header: "Detalle", accessorKey: "detalle_transaccion", size: 160 },
    ],
    []
  );

  const muiSearchTextFieldProps = {
    placeholder: "Buscar..",
    sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
    variant: "outlined",
    color: "success",
    size: "small",
  };

  const globalTheme = useTheme();

  const tableTheme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: globalTheme.palette.mode, //let's use the same dark/light mode as the global theme
          primary: globalTheme.palette.primary, //primary color for the table
          info: {
            main: "rgb(255,122,0)", //add in a custom color for the toolbar alert background stuff
          },
          background: {
            default:
              globalTheme.palette.mode === "light"
                ? "rgb(234, 239, 241)" //background in light mode
                : "#000", //pure black table in dark mode for fun
          },
        },
        typography: {
          button: {
            textTransform: "none", //customize typography styles for all buttons in table by default
            fontSize: "1.2rem",
          },
        },
        components: {
          MuiTooltip: {
            styleOverrides: {
              tooltip: {
                fontSize: "1.1rem", //override to make tooltip font size larger
              },
            },
          },
        },
      }),
    [globalTheme]
  );

  const initialState = {
    //para inicializar la tabla, y la cantidad de paginas q se ven ej 5
    density: "compact",
    showGlobalFilter: true,
    pagination: { pageIndex: 0, pageSize: 10 },
    columnVisibility: {
      id_articulo: false,
      uuid_articulo: false,
      estado: false,
    },
  };

  const tableHeadCellProps = {
    align: "left",
    sx: {
      fontSize: 16,
      color: "white",
      fontWeight: "normal",
      backgroundColor: "#2471A3",
      borderColor: "black",
    },
  };


  return (
      <div>
          <Navbar />
      <Container maxWidth="xl" mt={1} mb={2}>
        {modificaciones && tabla ? (
          <Box mt={2} boxShadow={3}>
            <ThemeProvider theme={tableTheme}>
              <MaterialReactTable
                enableColumnResizing
                enableExpandAll={false}
                muiTableHeadCellProps={tableHeadCellProps}
                enableToolbarInternalActions={true} //las acciones al lado del search (agregar y full screen)
                enableGrouping // para permitir agrupar x estado x ej
                layoutMode="grid"
                muiTableBodyCellProps={{
                  align: "left", //el contenido de la tabla
                }}
                enableColumnActions={true} //los puntitos de al lado de los titulos (acciones) -> hay que activarlo para agrupar x estado x ej
                enableColumnFilters={false} //desactiva filtros x  columna
                enableHiding={false} // opcion de ocultar columna pero activando el enablecolumaction
                enableDensityToggle={false} //
                localization={MRT_Localization_ES} //idioma
                enableColumnDragging={false} //para arrastrar columnas
                initialState={initialState}
                muiSearchTextFieldProps={muiSearchTextFieldProps}
                columns={columns}
                data={modificaciones} //con lo q la completas (esto cambia siempre)
                enableStickyFooter
                enableEditing
                positionActionsColumn="last" // posicion de la columna de acciones al final
                // ACCIONES
                renderTopToolbarCustomActions={() => (
                  <>
                    <Typography variant="poster" fontSize={26}>
                      Autorización de Modificaciones
                    </Typography>
                  </>
                )}
                renderToolbarInternalActions={(
                  { table } // boton para nuevo , al lado del buscar
                ) => (
                  <>
                    <MRT_FullScreenToggleButton table={table} />
                  </>
                )}
                renderRowActions={({ row, table }) => (
                  //las acciones del costado editar y ver
                  <div>
                    <Tooltip arrow placement="top" title="Autorizar artículo">
                      <IconButton
                        onClick={() => {
                          setAbrirConfirmacion(!abrirConfirmacion);
                          setArticuloRow(row.original);
                        }}
                        color="primary"
                      >
                        <TaskAltIcon />
                      </IconButton>
                    </Tooltip>
                  </div>
                )}
              />
            </ThemeProvider>
            <br />
          </Box>
        ) : null}
      </Container>
      {abrirConfirmacion ? (
        <Dialog_aut_modif
          row={articuloRow}
          abrirConfirmacion={abrirConfirmacion}
          onClose={() => handleOpenConfir(false)}
        />
      ) : null}
      </div>
  )
}

export default Autorizar_modificaciones;
